var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "py-0", attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        { attrs: { name: "campaign_factory_test" } },
        [
          _vm.campaignFactory.type === "live"
            ? _c("live-request-form-component", {
                attrs: { "collected-data": _vm.collectedData },
              })
            : _vm.campaignFactory.type === "opposition"
            ? _c("opposition-form-component", {
                attrs: { "collected-data": _vm.collectedData },
              })
            : _vm.campaignFactory.type === "postCollect"
            ? _c("post-collect-form-component", {
                attrs: { "collected-data": _vm.collectedData },
              })
            : _c("collect-form-component", {
                attrs: { "collected-data": _vm.collectedData },
                on: { "update-collected-data": _vm.updateCollectedData },
              }),
          _vm._v(" "),
          ["collect", "export"].includes(_vm.campaignFactory.type)
            ? _c("consent-grants-form-component", {
                attrs: { grants: _vm.advertiserConsentGrants },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "secondary",
              attrs: {
                type: "btn",
                disabled: !_vm.sendButtonEnabled,
                "data-cy": "btn-test",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("send-test")
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("campaign_factory.test.test")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          ["collect", "live"].includes(_vm.campaignFactory.type)
            ? _c(
                "v-btn",
                {
                  staticClass: "secondary",
                  attrs: {
                    type: "btn",
                    disabled: !_vm.sendButtonEnabled,
                    "data-cy": "btn-preview",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("send-preview")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("campaign_factory.test.preview")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { type: "reset" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.reset.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("campaign_factory.test.reset")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }